import React from 'react';
import { Col } from 'reactstrap';
import Layout from '../../components/Layout/Layout';
import { connect } from 'react-redux';
import { startSetDashboardSettings, startUpdateDashboardSettings } from '@actions/webmaster';
import DashboardSettings from '../../components/DashboardSettings/DashboardSettings';
import StatisticsChartWidget from '../../widgets/StatisticsChartWidget/StatisticsChartWidget';
import BannerWidget from '../../widgets/BannerWidget/BannerWidget';
import Loader from '@components/Loader/Loader';
import { items } from './itemsDashboard';

const renderWidjgetWithExtraProps = (item) => {
  const { localStorageName, collapsing, component } = item;
  return React.cloneElement(component, { collapsing, localStorageName });
};

const renderItemsByConfig = (config = [], items = []) => {
  if (Array.isArray(config) && Array.isArray(items)) {
    return config
      .sort((a, b) => a.position > b.position)
      .reduce((ordered, cfg) => {
        const item = items.find(({ id }) => cfg.id === id);
        if (item && cfg.enabled) {
          if (ordered[cfg.position]) {
            ordered[cfg.position + 1] = renderWidjgetWithExtraProps(item);
          } else {
            ordered[cfg.position] = renderWidjgetWithExtraProps(item);
          }
        }
        return ordered;
      }, []);
  }
};

const DashboardPage = ({ config, startUpdateDashboardSettings, startSetDashboardSettings }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [windowWidth, setWindowWidth] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  React.useEffect(() => {
    startSetDashboardSettings().then(() => setIsLoading((prev) => (prev = false)));
  }, []);

  const handleSettingsChange = (settings) => {
    startUpdateDashboardSettings(settings);
  };

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    if (typeof window !== 'undefined') {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const showBanner = windowWidth < 768;

  return isLoading ? (
    <Loader />
  ) : (
    <Layout formattedTitle="pages.dashboard.title" className="dashboard-page">
      <Col lg="12">
        <div className="dashboard-page-wrapper">
          <StatisticsChartWidget />
          {showBanner && <BannerWidget />}
          {renderItemsByConfig(config, items['main'])}
        </div>
      </Col>
      <DashboardSettings config={config} items={items} onChange={handleSettingsChange} />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  config: state.webmaster.dashboardSettings,
});

const mapDispatchToProps = (dispatch) => ({
  startUpdateDashboardSettings: (settings) => dispatch(startUpdateDashboardSettings(settings)),
  startSetDashboardSettings: () => dispatch(startSetDashboardSettings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
